/**
 * Design tokens — single source of truth for the True Forge visual system.
 * Derived from .claude/DESIGN_SYSTEM.md + PROJECT_RULES.md. Never hardcode these
 * values in components; always read them from here or from the MUI theme.
 */

export const colors = {
  gold: '#D4AF37',
  goldHover: '#C19F2E',
  bg: '#0D0D0D',
  surface: '#1B1B1B',
  surfaceAlt: '#141414',
  white: '#F5F5F5',
  grey: '#8A8A8A',
  border: 'rgba(245, 245, 245, 0.10)',
  borderStrong: 'rgba(245, 245, 245, 0.18)',
} as const

export const fonts = {
  // Oswald: condensed industrial display for headings. Manrope: modern, premium,
  // highly readable body. Space Grotesk: technical accent for buttons/labels/eyebrows.
  display: '"Oswald", "Arial Narrow", sans-serif',
  body: '"Manrope", system-ui, -apple-system, sans-serif',
  label: '"Space Grotesk", "Manrope", sans-serif',
} as const

export const layout = {
  /** Max content container width (px) — PROJECT_RULES: 1320. */
  containerMaxWidth: 1320,
  /** Max readable text measure (px) — COMPONENT_LIBRARY: ~700. */
  contentMaxWidth: 700,
  /** Sticky header height (px) — COMPONENT_LIBRARY: 88. */
  headerHeight: 88,
  /** Vertical section rhythm. Strings so MUI `sx` treats them as raw px. */
  sectionPaddingY: { xs: '72px', md: '112px', lg: '160px' } as const,
  radius: { card: 12, button: 12, pill: 999 },
  fabOffset: 24,
} as const

export const zIndex = {
  header: 1100,
  drawer: 1200,
  fab: 1050,
} as const
